<template>
    <div>
    </div>
</template>
  
<script>
import { setPageTitle,setRightTxt } from '@/bridge/AppJsBridge';
export default {
    data() {
      return {
      };
    },
    created() {
      this.initData();
    },
    methods: {
        initData() {
          setPageTitle('联系客服');
          setRightTxt("");
          window.location.replace(`https://www6c1.53kf.com/m.php?kf_sign=zgwMzMTY2NA0NTEyNDA1NjA5MDYyMDAyNzIyMzY5MjY%3D&cid=72236926&style=9&keyword=http%3A%2F%2F172.16.56.104%3A8021%2Fbox%2FcustomerService&referer=https%3A%2F%2Fh5.hzwxbz3.cn%2Fv2%2Fh5%2FmanualCustomer&guest_id=12344087488002&tpl=null&uid=95314d9bd0d1830aac1aed4ec7dd1d80&u_stat_id=null&talktitle=%E5%AE%A2%E6%9C%8D%E4%B8%AD%E5%BF%83&tfrom=51&device=&uuid_53kf=3f71872d9381f924ae5e36e70a7adca4&zdkf_type=1&kf=233168685%40qq.com%2C2443926209%40qq.com%2C2820522412%40qq.com%2C285324053%40qq.com%2C1121917012%40qq.com%2C361299145%40qq.com%2C3290039615%40qq.com%2C495120150%40qq.com%2C1281007696%40qq.com%2C1312257401%40qq.com%2C512700802%40qq.com%2C1051614381%40qq.com%2C563379768%40qq.com%2C3110344244%40qq.com%2C838263717%40qq.com%2C1011718178%40qq.com%2C1793852360%40qq.com%2C425519923%40qq.com%2C2446928157%40qq.com%2C2078016096%40qq.com%2C3195331848%40qq.com%2C2403292408%40qq.com%2Cwcnsszhongxin1213%40163.com&kflist=off&is_minchat=1&historylen=4&locahref=https%3A%2F%2Fh5.hzwxbz3.cn%2Fv2%2Fh5%2FmanualCustomer&fromopen=1#https://h5.hzwxbz3.cn/v2/h5/manualCustomer`);
        },
    },
};
</script>